<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs @change="callback">
        <a-tab-pane :key="0" tab="总部"></a-tab-pane>
        <a-tab-pane :key="2" tab="门店"></a-tab-pane>
      </a-tabs>
      <a-radio-group class="m-b-15" v-model:value="search.lately_time" button-style="solid" @change='selectDay'>
        <a-radio-button value="">全部</a-radio-button>
        <a-radio-button :value="1">近7天</a-radio-button>
        <a-radio-button :value="2">近30天</a-radio-button>
        <a-radio-button :value="3">自定义时间</a-radio-button>
      </a-radio-group>
      <a-range-picker class="m-l-10"   v-if="search.lately_time==3" @change="onChange" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' :disabledDate="disabledDate" @calendarChange="calendarPriceRangeChange"/>
      <p></p>
      <a-radio-group class="m-b-15" v-model:value="search.datatype" button-style="solid" @change='selectChange'>
        <a-radio-button value="all">全部订单</a-radio-button>
        <a-radio-button value="pay">待付款</a-radio-button>
        <a-radio-button value="delivery">待发货</a-radio-button>
        <a-radio-button value="receipt">待收货</a-radio-button>
        <a-radio-button value="write_off">待核销</a-radio-button>
        <a-radio-button value="auto_write_off">系统自动核销</a-radio-button>
        <a-radio-button value="evaluate">待评价</a-radio-button>
        <a-radio-button value="complete">已完成</a-radio-button>
        <a-radio-button value="agglomerate">成团中</a-radio-button>
        <a-radio-button value="agglomerate_fail">成团失败</a-radio-button>
        <a-radio-button value="refund">退款中</a-radio-button>
        <a-radio-button value="refund_success">退款成功</a-radio-button>
        <!-- <a-radio-button value="settled_success">已结算</a-radio-button> -->
      </a-radio-group>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item class='mb15' label="" name='keywords'>
          <a-input-group compact :style="{width:'360px'}">
            <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
              <a-select-option value="order_no">订单号</a-select-option>
              <a-select-option value="user_id">买家ID</a-select-option>
              <a-select-option value="phone">联系手机</a-select-option>
              <a-select-option value="name">收货人</a-select-option>
              <a-select-option value="product_name">商品名称</a-select-option>
              <a-select-option value="express_no">运单号</a-select-option>
              <a-select-option value="member_name">微信昵称</a-select-option>
              <a-select-option value="reality_order_no">交易单号</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword"  placeholder="请输入关键词进行搜索"/>
          </a-input-group>
        </a-form-item>
        <a-form-item label="收货区域" name='level_id' v-if='open'>
          <a-select class='m-r-10' v-model:value="search.province_id" :style="{width:'140px'}" placeholder="全部" @change="selectProvince">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for='(item,index) in provinceList' :key="index" :value="item.id">{{item.name}}
            </a-select-option>
          </a-select>
          <a-select v-model:value="search.city_id" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for='(item,index) in cityList' :key="index" :value="item.id">{{item.name}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="订单类型" name='order_type' v-if='open' @change="selectOrderType">
             <a-select class='m-r-10' v-model:value="search.order_type" :style="{width:'140px'}" placeholder="请选择">
            <a-select-option value="">全部订单</a-select-option>
            <a-select-option :value="1">普通订单</a-select-option>
            <a-select-option :value="2">秒杀订单</a-select-option>
            <a-select-option :value="3">拼团订单</a-select-option>
            <!-- <a-select-option :value="4">奖品订单</a-select-option> -->
            <!-- <a-select-option :value="10">直播订单</a-select-option> -->
            <a-select-option :value="99">总部代发订单</a-select-option>
            <a-select-option :value="6">夺宝订单</a-select-option>
              <a-select-option :value="7">权益卡订单</a-select-option>
          </a-select>
        </a-form-item>
     <!--    <a-form-item label="优惠折扣" name='rebate_type' v-if='open && (search.order_type == 1 || search.order_type == "")'>
          <a-select v-model:value="search.rebate_type" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="2">满额包邮</a-select-option>
            <a-select-option :value="1">满额减送</a-select-option>
            <a-select-option :value="3">优惠券折扣</a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item label="发货门店" name='order_source' v-if='open && search.store_type == 2' >
            <a-input-group compact >
            <a-select v-model:value="search.source_type" style="width:100px" @change="search.source_type_keywork=''">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="dealer">经销商</a-select-option>
              <a-select-option value="store">门店</a-select-option>
            </a-select>
            <a-input style="width:200px" v-model:value="search.source_type_keywork"  :placeholder="search.source_type=='dealer'?'请输入经销商名称':'请输入门店名称'" v-if="search.source_type"/>
          </a-input-group>
          <!-- <a-input class="m-r-10" style="width: 160px" v-model:value="search.dealer_name" readonly  placeholder="经销商名称"/>
          <div class="s_po_re" style="display: inline-block;">
            <a-input class="m-r-10" style="width: 160px" v-model:value="search.store_name" v-if='search.store_name' readonly  placeholder="门店名称"/>
            <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 15px;top: 12px;" v-if='search.store_name'  @click='search.store_name="";search.source_id=dealer_id;search.order_source=1' />
          </div>
          <a-button class="m-r-10" type="primary" @click='showDealer = true'>选择</a-button> 
          <a-button type="primary" ghost v-if='search.dealer_name' @click='search.dealer_name="";search.store_name="";search.order_source=1;search.source_id=""'>重置</a-button> -->
        </a-form-item>
         <a-form-item label="发货方式" name='delivery_type' v-if='open && search.store_type == 2' >
             <a-select v-model:value="search.delivery_type" style="width:100px" >
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="2">门店自提</a-select-option>
              <a-select-option value="1">快递发货</a-select-option>
            </a-select>
        </a-form-item>
        <!-- <a-form-item label="支付方式" name='pay_type' v-if='open && (search.order_type == 1 || search.order_type == "")'>
          <a-select class='m-r-10' v-model:value="search.pay_type" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">微信</a-select-option>
            <a-select-option :value="2">积分</a-select-option>
          </a-select>
        </a-form-item> -->
   
        <a-form-item>
          <a-button type="primary" htmlType='submit' class="m-r-10">搜索</a-button>
           <a-button v-has:cloudOrderExport="exportTable">导出</a-button>
        </a-form-item>
        <!-- <a-form-item>
          <a-button type="primary" ghost>导出</a-button>
        </a-form-item> -->
        <!-- <a-form-item>
          <a-button type="primary" ghost>批量发货</a-button>
        </a-form-item> -->
        <a-form-item>
          <a href="javascript:;" @click='open = !open'>{{open ? '收起':'展开'}}</a>
          <UpOutlined v-if='open'/>
          <DownOutlined  v-else/>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :columns='columns' :data-source='data' class="tableFixBox" :scroll="{ x: 'max-content'}">
        <template v-slot:order_no="{ record }">
          {{record.order_no}}
          <p>{{record.order_type_text}}</p>
        </template>
        <template v-slot:user="{ record }">
          <a-popover placement="right">
            <template #content>
              <div class="s_flex_ali">
                <img class="width-100 height-100 m-r-15" :src="record.user.wechatUser ? record.user.wechatUser.headimgurl : ''" alt="">
                <div>
                  <p class="s_c333 s_lin_h28">微信昵称：{{record.user.wechatUser ? record.user.wechatUser.nickname : "-" }}</p>
                  <p class="s_c333 s_lin_h28">客户ID：{{record.user ? record.user.id :'-'}}</p>
                  <p class="s_c333 s_lin_h28">地区：{{record.user.wechatUser ? record.user.wechatUser.province+record.user.wechatUser.city : "-"}}</p>
                  <p class="s_c333 s_lin_h28">会员等级：{{record.user ? record.user.vip_level : "-"}}</p>
                </div>
              </div>
            </template>
            <a-button type="link">
              {{record.user ? record.user.member_name :'-'}}
            </a-button>
          </a-popover>
        </template>
        <template v-slot:detail="{ record }">
          <div v-if='record.detail.length == 1'>
            <div v-for="(item,index) in record.detail" :key='index'>
              <a-card-meta>
                <template #avatar>
                  <img :src="info.picdomain+'/'+(item.product_image)" alt="" style="width:50px;height:50px">
                </template>
                <template #description>
                  <p class="s_omit2" style="width: 320px;">{{item.product_name}}</p>
                  <!-- <p class="s_omit">{{item.product_name}}</p> -->
                </template>
              </a-card-meta>
            </div>
          </div>
          <div class="s_flex_ali" v-else>
            <div class="m-r-10" v-for="(item,index) in record.detail" :key='index'>
              <img :src="info.picdomain+'/'+(item.product_image)" alt="" style="width:50px;height:50px">
            </div>
          </div>
        </template>
        <template v-slot:delivery_type="{ record }">
          <p>{{record.delivery_type == 1 ?'快递发货':'门店自提'}}</p>
        </template>
        <template v-slot:store_name="{ record }">
          <p>发货门店：{{record.store_name}}</p>
          <p>所属上级：{{record.parent_name}}</p>
        </template>
        <template v-slot:pay_price="{ record }">
          <p>￥{{record.pay_price}}</p>
          <p class="s_c999">（含运费{{record.freight_price}}）</p>
        </template>
        <template v-slot:action="{ record }">
          <a-dropdown>
            <a class="ant-dropdown-link"> 操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <a href="javascript:;" v-has:cloudOrderDetail="()=> {$router.push('/order/order_list/order_more?id='+record.order_no)}">详情</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;" v-has:cloudOrderEditRemarks='()=>getRemarks(record)'>编辑备注</a>
                </a-menu-item>
                <a-menu-item v-if='record.order_status == 5'>
                  <a href="javascript:;" v-has:cloudOrderAfterSale="()=> {$router.push('/order/order_manage/return_order_more?id='+record.order_no)}">售后处理</a>
                </a-menu-item>
                <a-menu-item  v-if='(record.order_status == 1 || record.order_status == 2) && record.delivery_type == 1'>
                  <a v-has:cloudOrderEditAddress="()=>getAddress(record)" href="javascript:;">修改地址</a>
                </a-menu-item>
                <a-menu-item  v-if='(record.order_status == 1 || record.order_status == 6) && record.delivery_type == 1'>
                  <a v-has:cloudOrderShip="()=>orderDeliver(record,1)" href="javascript:;">发货</a>
                </a-menu-item>
                <a-menu-item v-if='record.order_status == 1'>
                  <a v-has:cloudOrderRefund="()=>orderRefunds(record)" href="javascript:;">退款</a>
                </a-menu-item>
                <!-- <a-menu-item v-if='record.order_status == 2 && record.delivery_type == 1'>
                  <a @click="orderDeliver(record,2)" href="javascript:;" >修改发货</a>
                </a-menu-item> -->
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数:${total} `" />
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false"
    title="订单备注"
    centered
    v-model:visible="showRemarks"
    :confirm-loading="confirmLoading"
    @ok="eidtRemarks"
    destroyOnClose
  >
    <a-textarea v-model:value="orderRemarks" placeholder="请输入订单备注内容" :rows="4" />
  </a-modal>
  <a-modal  :keyboard="false"
    title="修改收货地址"
    :width='600'
    centered
    :footer="null"
    v-model:visible="showAddress"
    destroyOnClose
  >
    <addressChange :addressData='addressData' v-on:submitaddress='submitAddress'></addressChange>
  </a-modal>
  <a-modal  :keyboard="false"
    title="退款"
    :width='600'
    centered
    :footer="null"
    v-model:visible="showRefunds"
    destroyOnClose
  >
    <refundsForem :refundsData='refundsData' type='list' v-on:submitrefunds='submitrefunds'></refundsForem>
  </a-modal>
  <a-modal  :keyboard="false"
    :title="deliverType == 1 ?'标记发货':'修改发货'"
    :width='1300'
    centered
    :footer="null"
    v-model:visible="showDeliver"
    destroyOnClose
  >
    <deliverForem :deliverData='deliverData' :type='deliverType' :isInsteadShip='1' v-on:submitdeliver='submitdeliver'></deliverForem>
  </a-modal>
  <a-modal  :keyboard="false" centered title="选择门店" v-model:visible="showStore" :width='1300' :footer="null" destroyOnClose>
    <selectStore v-on:select="storeSelect" :dealer_id='dealer_id' :hiddenHead='true'></selectStore>
  </a-modal>
  <a-modal  :keyboard="false" centered title="选择经销商" v-model:visible="showDealer" :width='1300' :footer="null" destroyOnClose>
    <selectDealer v-on:select="dealerSelect"></selectDealer>
  </a-modal>
</template>
<script>
import { DownOutlined,UpOutlined } from "@ant-design/icons-vue";
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
import { getOrderList,orderAddressEdit,setOrderRemark,getOrderRemark,orderAddressMore } from "@/api/order";
import { iscode } from "@/utils/app";
import { getArea } from "@/api/public";
import {userExportTable} from '@/hooks/userExportTable'
import store from "@/store";
import { useTime } from "@/hooks/utils/useTime";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 5,
  datatype:'all',
  store_type:0,
  lately_time:'',
  start_time:'',
  end_time:'',
  province_id:'',
  city_id:'',
  key_type:'order_no',
  keyword: "",
  order_type:'',
  rebate_type:'',
  pay_type:'',
  order_source:1,
  source_id:'',
  source_type:'',
  source_type_keywork:'',
  delivery_type:''
};
export default {
  components: { DownOutlined ,UpOutlined},
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const momentTime=inject('momentTime')
    const state = reactive({
      disabledDate: (current)=> {
        // return  current && current > momentTime().subtract(0, 'days').endOf('day')
        if (search.value.start_time) {
          let offsetDays= 86400000 * 89;
          let selectV = momentTime(search.value.start_time, 'YYYY-MM-DD').valueOf()
          return (current > momentTime().subtract(0, 'days').endOf('day') || current >momentTime(new Date(selectV + offsetDays), "YYYY-MM-DD")) || current < momentTime(new Date(selectV - offsetDays), "YYYY-MM-DD")
        } else {
           return current && current > momentTime().subtract(0, 'days').endOf('day');
        }
      },
      dealer_id:'',
      deliverType:1,
      info: store.state.user.info,
      orderRemarks:'',
      orderId:'',
      provinceList:[],
      cityList:[],
      open:false,
      showAddress:false,
      showRefunds:false,
      showDeliver:false,
      listLoading: false,
      showRemarks:false,
      showStore:false,
      showDealer:false,
      time:[],
      total: 1,
      selectedRowKeys:[],
      addressData:{},
      deliverData:{},
      refundsData:{},
      confirmLoading:false,
      activeKey:1
    });
    let columns =ref( [
      {
        title: "订单号/类型",
        dataIndex: "order_no",
        key: "order_no",
        slots: { customRender: "order_no" }
      },
      {
        title: "买家昵称",
        dataIndex: "user",
        key: "user",
        slots: { customRender: "user" },
      },
      {
        title: "订单商品",
        dataIndex: "detail",
        key: "detail",
        slots: { customRender: "detail" },
      },
  
      {
        title: "总数量/件",
        dataIndex: "product_all_total",
        key: "product_all_total",
        align:'center',
      },
      {
        title: "交易信息",
        dataIndex: "pay_price",
        key: "pay_price",
        align:'center',
        slots: { customRender: "pay_price" },
      },
 
      {
        title: "订单状态",
        dataIndex: "order_status_text",
        key: "order_status_text",
        align:'center',
      },
      {
        title: "下单时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "操作",
        key: "action",
        fixed: 'right',
        slots: { customRender: "action" },
      },
    ]);
    const $router = inject('$router')
    const $Modal = inject('$Modal')

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const { dateTargets, typeToStartEnd } = useTime();
    // 选择订单筛选时间
    const selectDay=(e)=>{
      var value=e.target.value
        switch(value){
          case "":
               search.value.end_time = ''
              search.value.start_time = ''
          break;
          case 1:
              search.value.end_time = typeToStartEnd("1").end_time;
              search.value.start_time = typeToStartEnd("7").start_time;
          break;
          case 2:
              search.value.end_time = typeToStartEnd("1").end_time;
              search.value.start_time = typeToStartEnd("30").start_time;
          break;
        }
        if(value!=3){
           search.value.page = 1;
           initData(search.value);
        }
    } 

    // 切换订单类型
    const selectOrderType =() =>{
      search.value.pay_type = ''
      search.value.rebate_type = ''
    }
    // 切换选项搜索
    const selectChange = (e) =>{
      search.value.page = 1;
      initData(search.value);
    }
    // 切换总部/门店
    const callback = (e) =>{
      search.value.store_type = e;
      search.value.page = 1;
      // columns.value[4].title=e==0?'订单类型':'发货门店'
      if(e == 2){
        columns.value.splice(4,0,{
          title: "发货方式",
          dataIndex: "delivery_type",
          key: "delivery_type",
          slots: { customRender: "delivery_type" },
        },
        {
          title: "发货门店",
          dataIndex: "store_name",
          key: "store_name",
          slots: { customRender: "store_name" },
        })
      }else{
        var index = columns.value.findIndex(v=>v.title=='发货方式')
        columns.value.splice(index,2)
      }
      initData(search.value);
    }
    //获取省市区
    const getAreaList = async () => {
      let result = await getArea().then(res => res)
      state.provinceList = result.data
    }
    // 收货区域选择省
    const selectProvince = (e, option) => {
      if (e && option) {
        state.cityList = state.provinceList[option.key].children
      } else {
        state.cityList = []
      }
      search.value.city_id = ''
    }
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0]
      search.value.end_time = e[1]
      initData(search.value);
    }
    //批量选中
    const onSelectChange = (selectedRowKeys) => {
      state.selectedRowKeys = selectedRowKeys;
    }
    
    //获取备注
    const getRemarks = async(e) =>{
      let res=await getOrderRemark({order_no:e.order_no}).then(res=>res.data).catch(error=>error)
      if (iscode(res)) {
        state.showRemarks = true;
        state.orderRemarks = res.data.store_remark;
        state.orderId = e.order_no;
      } else {
        message.error(res.msg);
      }
    }
    //修改备注
    const eidtRemarks = async() =>{
      state.confirmLoading = true
      let res=await setOrderRemark({order_no:state.orderId,store_remark:state.orderRemarks}).then(res=>res.data).catch(error=>error)
      if (iscode(res)) {
        state.showRemarks = false;
        state.orderRemarks = '';
        state.orderId = '';
        message.success(res.msg);
      } else {
        message.error(res.msg);
      }
      state.confirmLoading = false
    }
    //获取订单地址
    const getAddress = async(e) =>{
      let res=await orderAddressMore({order_no:e.order_no}).then(res=>res.data).catch(error=>error)
      if (iscode(res)) {
        state.showAddress = true;
        var detailText = res.data[0].detail.split(',')
        res.data[0].detail = detailText[1]
        res.data[0].city_texts = detailText[0]
        console.log(detailText)
        state.addressData = res.data[0];
      } else {
        message.error(res.msg);
      }
    }
    //确认修改地址
    const submitAddress = (e) =>{
      state.showAddress = false;
      initData(search.value);
    }
    //打开退货弹窗
    const orderRefunds = (e) =>{
      state.refundsData = e
      state.showRefunds = true
    }
    //退货
    const submitrefunds = (e) =>{
      state.showRefunds = false;
      initData(search.value);
    }
    //打开发货弹窗
    const orderDeliver = (e,type) =>{
      state.deliverType = type
      state.deliverData = e
      state.showDeliver = true
    }
    //发货
    const submitdeliver = (e) =>{
      state.showDeliver = false;
      initData(search.value);
    }
    //选择经销商
    const dealerSelect = (e) =>{
      state.showDealer = false
      state.showStore = true
      search.value.source_id = e.dealer_id || 0
      state.dealer_id = e.dealer_id
      search.value.dealer_name = e.dealer_name || '总部'
      search.value.store_name = ''
    }
    //选择门店
    const storeSelect = (e) =>{
      state.showStore = false
      search.value.source_id = e.id
      search.value.store_name = e.store_name
      search.value.order_source = 2;
    }
    //获取列表
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getOrderList(values).then(res=>res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    const inputSelect = (e) =>{
      search.value.keyword = ''
    }
    
    onMounted(() => {
      // 查看是否有留存状态，有则替换
      let pageState = getPageState(getRouter().route.path);
      if (pageState) {
        search.value = Object.assign(search.value, pageState);
      }
      getAreaList();
      initData(search.value);
    });

    // 导出
    const {exportHandle}=userExportTable()
    const exportTable=()=>{
        exportHandle('v1/order/export',{...search.value,limit:5000})
    }

    const calendarPriceRangeChange = function(e){
       search.value.start_time = e[0]
    }


    return {
      ...toRefs(state),
      search,
      data,
      columns,
      exportTable,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      onSelectChange,
      submitAddress,
      callback,
      selectProvince,
      selectChange,
      selectDay,
      inputSelect,
      eidtRemarks,
      getRemarks,
      getAddress,
      orderDeliver,
      orderRefunds,
      submitrefunds,
      submitdeliver,
      dealerSelect,
      storeSelect,
      selectOrderType,
      calendarPriceRangeChange
    };
  },
};
</script>